// extracted by mini-css-extract-plugin
export default {"statusIndicator":"status-indicator_statusIndicator__H5yew"};